import script from "./Step1DatosComprador.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1DatosComprador.vue?vue&type=script&setup=true&lang=js"

import "./Step1DatosComprador.vue?vue&type=style&index=0&id=e6768402&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6768402"]])

export default __exports__